import type { AccountsWalletsTranslations } from "@/shared/lang/interfaces/accountsWallets";

export const METHOD_OPTION_LABEL_KEYS: Record<
  string,
  keyof AccountsWalletsTranslations
> = {
  Ahorros: "form_method_option_ahorros",
  Corriente: "form_method_option_corriente",
  CPF: "form_method_option_cpf",
  CNPJ: "form_method_option_cnpj",
  Email: "form_method_option_email",
  Teléfono: "form_method_option_telefono",
  "Llave aleatoria": "form_method_option_llave_aleatoria",
  "ID FPS": "form_method_option_id_fps",
  NIT: "form_method_option_nit",
  CC: "form_method_option_cc",
  CE: "form_method_option_ce",
  PASAPORTE: "form_method_option_pasaporte",
  PPT: "form_method_option_ppt",
};

export const METHOD_FIELD_PLACEHOLDER_KEYS: Record<
  string,
  keyof AccountsWalletsTranslations
> = {
  clabe: "form_method_placeholder_clabe",
};
